var _defs, _rect, _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2BInvite2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2bInvite2Sky",
    x1: 0,
    y1: 0,
    x2: 0.2,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#dbe7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#b7c4c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2c3338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2bInvite2Silk",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f7f1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c9b8a6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#b2bInvite2Sky)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1280,
    cy: 210,
    rx: 340,
    ry: 180,
    fill: "#f4f7fb",
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420 900 C 480 540 720 280 980 240 C 1120 380 980 620 1080 900 Z",
    fill: "url(#b2bInvite2Silk)",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 740 C 260 660 480 780 760 700 C 1040 620 1280 760 1600 680 L 1600 900 L 0 900 Z",
    fill: "#1f2428",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BInvite2);
export default __webpack_public_path__ + "static/media/b2b-invite-2.1bae0f5f37eeaa838148d53d5003a817.svg";
export { ForwardRef as ReactComponent };